import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeFileLabel: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.file-card.remove-file-label',
		defaultMessage: 'Remove file',
		description: 'Label text cross icon button to remove a CMDB import file',
	},
});
